import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Inventory.types'

@Injectable({ providedIn: 'root' })
export class Inventory_add_inventory_on_existing_licenseplate_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { licenseplateId: number, lotId: number, packagingId: number, packagedAmount: number, reasoncodeId: number, operationcodeId: number }): Promise<{ reasons?: string[], confirm?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplateId)) {
      missingRequiredInParams.push('\'licenseplateId\'');
    }
    if (isNil(inParams.lotId)) {
      missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil(inParams.packagingId)) {
      missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil(inParams.packagedAmount)) {
      missingRequiredInParams.push('\'packagedAmount\'');
    }
    if (isNil(inParams.reasoncodeId)) {
      missingRequiredInParams.push('\'reasoncodeId\'');
    }
    if (isNil(inParams.operationcodeId)) {
      missingRequiredInParams.push('\'operationcodeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/functions/add_inventory_on_existing_licenseplate_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

